
<h1 mat-dialog-title>{{ title }}</h1>

<mat-divider></mat-divider>
<div class="list-container">

  <div mat-dialog-content [formGroup]="form">

    @if (commissionSeances) {
      <mat-selection-list formControlName="commissionSeancesForm" [multiple]="multiple">
        @for (item of commissionSeances | keyvalue: sortByCommissionType; track item) {
          <h3 matSubheader>{{ item.value.commissionType.label }}</h3>
          @for (reunion of item.value.commissionSeances; track reunion) {
            <mat-list-option [value]="reunion">
              <div matListItemAvatar>
                <div class="avatar-{{ reunion?.commission?.code }}">{{ reunion?.commission?.code }}</div>
              </div>
              <div matListItemTitle>{{ reunion.label }}</div>
              <div matListItemLine class="text-gray">
                {{reunion?.datetimeDebut|date:'dd/MM/yyyy' }}
                @if (reunion.datetimeFin && reunion.datetimeFin !== reunion.datetimeDebut) {
                  ⭢
                  {{reunion?.datetimeFin|date:'dd/MM/yyyy' }}
                }
              </div>
            </mat-list-option>
          }
        }
      </mat-selection-list>
    }

  </div>

</div>




<mat-dialog-actions>
  @if (cancel) {
    <button mat-button [mat-dialog-close]="[]">{{cancel}}</button>
  }
  <button mat-raised-button color="primary" [mat-dialog-close]="form.get('commissionSeancesForm').value">{{confirm}}</button>
</mat-dialog-actions>
